// removed by extract-text-webpack-plugin
module.exports = {"form":"styles__form___Rf6lF"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/ConsumptionProfile/components/ProductForm/styles.css
// module id = 2931
// module chunks = 0